import React, { useState, useEffect, useRef } from "react";
import API from "../api";
import { useAuth } from "../context/AuthContext";
import { Form, Button, Table } from "react-bootstrap";

export default function AdminEnterPointsPage() {
  const { user } = useAuth();

  const [weeks, setWeeks] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState("");
  const [teams, setTeams] = useState([]);
  const [points, setPoints] = useState([]);

  const inputRefs = useRef({}); // For Auto-Tab by team_id

  useEffect(() => {
    if (user?.leagueid) {
      fetchWeeks();
    }
  }, [user]);

  const fetchWeeks = async () => {
    try {
      const res = await API.get(`/league/${user.leagueid}/weeks`);
      setWeeks(res.data);
    } catch (err) {
      console.error("Failed to fetch weeks", err);
    }
  };

  const handleWeekChange = async (weekId) => {
    setSelectedWeek(weekId);
    setPoints([]);
    setTeams([]);

    try {
      // Fetch teams first (ordered like scorecards)
      const teamRes = await API.get(`/teams/ordered/${user.leagueid}/${weekId}`);
      const loadedTeams = teamRes.data;
      setTeams(loadedTeams);

      // Fetch existing points for the week
      const pointsRes = await API.get(`/points/${user.leagueid}/${weekId}`);
      const existingPoints = pointsRes.data;

      // Build points array from teams
      const initial = loadedTeams.map(team => {
        const existing = existingPoints.find(p => p.team_id === team.id);
        return {
          team_id: team.id,
          team_name: team.name,
          points: existing ? existing.points : ""
        };
      });

      setPoints(initial);
    } catch (err) {
      console.error("Failed to load teams or points", err);
    }
  };

  const handlePointsChange = (teamId, value) => {
    setPoints(prev => prev.map(p => {
      if (p.team_id === teamId) {
        return { ...p, points: value };
      }
      return p;
    }));
  };

  const handleKeyDown = (e, teamId) => {
    if (e.key === "Enter" || e.key === "Tab") {
      e.preventDefault();

      // Get all team IDs in order
      const teamIds = points.map((team) => team.team_id);
      const currentIndex = teamIds.indexOf(teamId);

      if (currentIndex > -1 && currentIndex < teamIds.length - 1) {
        const nextTeamId = teamIds[currentIndex + 1];
        inputRefs.current[nextTeamId]?.focus();
      }
    }
  };

  const handleSubmit = async () => {
    try {
      await API.post("/points/submit", {
        league_id: user.leagueid,
        week_id: selectedWeek,
        points: points
      });
      alert("Points saved successfully!");
    } catch (err) {
      console.error("Failed to submit points", err);
      alert("Failed to submit points.");
    }
  };

  return (
    <div className="container mt-4">
      <h3>Enter Points</h3>

      <Form.Group className="mb-3">
        <Form.Label>Select Week</Form.Label>
        <Form.Select value={selectedWeek} onChange={(e) => handleWeekChange(e.target.value)}>
          <option value="">Select a week...</option>
          {weeks.map(week => (
            <option key={week.id} value={week.id}>
              Week {week.week_number} - {week.date}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      {selectedWeek && teams.length > 0 && (
        <>

	<Table bordered striped responsive style={{ maxWidth: "300px" }}>
  <thead>
    <tr>
      <th style={{ width: "150px" }}>Team</th>
      <th style={{ width: "80px" }}>Points</th>
    </tr>
  </thead>
  <tbody>
    {points.map(team => (
      <tr key={team.team_id}>
        <td style={{ width: "150px" }}>{team.team_name}</td>
        <td style={{ width: "80px" }}>
          <Form.Control
            type="number"
            style={{ maxWidth: "70px" }}
            ref={(el) => {
              if (el) inputRefs.current[team.team_id] = el;
            }}
            value={team.points}
            onChange={(e) =>
              handlePointsChange(team.team_id, e.target.value)
            }
            onKeyDown={(e) => handleKeyDown(e, team.team_id)}
            min="0"
          />
        </td>
      </tr>
    ))}
  </tbody>
</Table>


          <Button variant="primary" onClick={handleSubmit}>
            Save Points
          </Button>
        </>
      )}
    </div>
  );
}
